import axios from 'axios';
// import { SECOND_BASE_URL, TEST_URL } from "./constants";

export const $api = axios.create({
  baseURL: `${process.env.NEXT_PUBLIC_TEST_URL}/client`,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json'
  }
});

export const $apiV2 = axios.create({
  baseURL: process.env.NEXT_PUBLIC_TEST_URL_V2,
  withCredentials: true,
});

export const $apiWithoutClient = axios.create({
  baseURL: process.env.NEXT_PUBLIC_TEST_URL,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json'
  }
});

export const $apiNews = axios.create({
  baseURL: process.env.NEXT_PUBLIC_SECOND_BASE_URL,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json'
  }
});

$api.interceptors.request.use(req => {
  if (process.env.NODE_ENV === 'development') {
    console.log('%c[REQUEST]', `[${req.method?.toUpperCase()}]`, req.url);
    console.log('[PARAMS]', req.params);
  }

  return req;
});

$apiWithoutClient.interceptors.request.use(req => {
  if (process.env.NODE_ENV === 'development') {
    console.log('%c[REQUEST]', `[${req.method?.toUpperCase()}]`, req.url);
    console.log('[PARAMS]', req.params);
  }

  return req;
});

$apiNews.interceptors.request.use(req => {
  if (process.env.NODE_ENV === 'development') {
    console.log('%c[REQUEST]', `[${req.method?.toUpperCase()}]`, req.url);
    console.log('[PARAMS]', req.params);
  }

  return req;
});